import React from 'react';
import './App.css';
// ============ Dashboard
import Navbar from './js/Navbar';
import Jumbotron from './js/Jumbotron';
import CompanyLogos from './js/CompanyLogos';
import AboutUs from './js/AboutUs';
import Products from './js/Products';
import OrderNow from './js/OrderNow';
import Footer from './js/Footer';
// ============ ProductDetail
import NavbarDetail from './js/NavbarDetail';
import ProductDetail from './js/ProductDetail';
import FooterDetail from './js/FooterDetail';
// ============ Admin
import Login from './js/Login';
import AdminUpload from './js/AdminUpload';
import AdminList from './js/AdminList';
import AdminEdit from './js/AdminEdit';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import { ScrollSpy } from 'organism-react-scroll-nav';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

function App() {
  return (
    <div className="App">
      <Router>
        <Switch>
          <Route path="/admin/new">
            <AdminUpload />
          </Route>
          <Route path="/admin/edit">
            <AdminEdit />
          </Route>
          <Route path="/admin">
            <AdminList />
          </Route>
          <Route path="/login">
            <Login />
          </Route>
          <Route path="/product">
            <NavbarDetail />
            <ProductDetail />
            <FooterDetail />
          </Route>
          <Route path="/">
            <Navbar />
            <ScrollSpy id="Home">
              <Jumbotron />
              <CompanyLogos />
            </ScrollSpy>
            <ScrollSpy id="AboutUs" style={{ paddingTop: 80 }}>
              <AboutUs />
            </ScrollSpy>
            <ScrollSpy id="Products" style={{ paddingTop: 20 }}>
              <Products />
            </ScrollSpy>
            <ScrollSpy id="OrderNow" style={{ paddingTop: 20 }}>
              <OrderNow />
            </ScrollSpy>
            <Footer />
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
